module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Stateoff  Social Block */
(function(fox) {

	fox.registerWidget('Stateoff_SocialApps_Block', {

		configure: function () {
			this.registerOptions('', {
				manualRender: true,
				template: 'stateoff_social_appsblock',
				container: '#find-me',
				widgets: {
					socialApps: {
						'embed.container': '#find-me-container',
						widget: 'SocialApps',
						drawImage: false,
						'list.tpl.row': 'stateoff_social_apps_row',
						appDomElementOptions: {
							'twitter.linkClass': 'stateoff-icon-socialTwitter_44',
							'facebook.linkClass': 'stateoff-icon-socaialFacebook_44',
							'instagram.linkClass': 'stateoff-icon-socialInstagram_44',
							'tumblr.linkClass': 'stateoff-icon-socialThumblr_44'
						},
						'widgets.appsDatalayer.hooks.onLoaded': function() {
							if (!fox.isEmpty(this.getCollection())) {
								var socialAppsBlock = fox.wom.selectFirst('~#socialAppsBlock');
								socialAppsBlock.render();
								socialAppsBlock.setOption('manualRender', false);
								this.dispatchEvent('loaded');
							}
						}
					}
				}
			})
		
			this.callParent('configure', arguments);
		}

	}, 'Widget');
	
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/stateoff/socialAppsBlock.js
// module id = 903
// module chunks = 4